/**
 * Binding of fetch (ajax) async forms. Singleton.
 * @class AsyncForm
 */

import { loadData } from './helpers';
import { callbacks } from './callbacks';
import serialize from 'form-serialize';
import 'header-message';
import togglePasswordFieldType from './toggle-password-field-type';

class AsyncForm {
  constructor() {
    this.init = this.init.bind(this);
  }

  init() {
    [...document.querySelectorAll('.js-async-form')].map(form => {
      if (form.classList.contains('js-loader')) {
        this.button = form.querySelector('button[type="submit"]');
      }

      if (!form.getAttribute('data-init')) {
        form.setAttribute('data-init', 'true');

        form.addEventListener('submit', event => {
          event.preventDefault();
          const callback = callbacks[form.getAttribute('data-callback')];

          this.startSpinner();
          loadData(
            form.getAttribute('action'),
            serialize(form, {
              hash: true,
            }),
          )
            .then(response => {
              if (typeof callback === 'function') {
                callback(form, response);
                if (form.getAttribute('data-next') === 'true'){
                  form.innerHTML = response.html;
                  setTimeout(() => {
                    window.location.href = response.next;
                  }, 1000);
                }
                if (response.error) {
                  togglePasswordFieldType(form.querySelectorAll('.passwordInputField__Wrapper'));
                }
              }
            })
            .catch((error) => {
              console.warn(error);
              this.stopSpinner();
            });
          window.onunload = () => this.stopSpinner();
        });
      }
    });
  }

  startSpinner() {
    if (this.button) {
      this.button.setAttribute('disabled', true);
      this.button.classList.add('loading');
    }
  }

  stopSpinner() {
    if (this.button) {
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  }
}

export const asyncForm = new AsyncForm();



// WEBPACK FOOTER //
// ./src/js/async-form.js